<template>
  <div
    v-if="!storyblokAdmin.isInStoryblokAdmin() && globalContent.getHasDifferentEndConsumerTypes"
    class="ConsumerType flex type-sm desk:type-xs mobOnly:h-24 items-end gap-12 desk:h-full"
    :class="textClass"
  >
    <div
      v-if="globalContent.getB2cEnabled"
      ref="b2cRef"
      class="border-b-2 pb-4 desk:pb-10"
      :class="globalContent.getIsB2c
        ? 'type-headline-sm desk:type-headline-xs'
        : 'border-transparent opacity-75 hover:opacity-100 transition-all duration-300 ease-out'"
    >
      <a
        :href="b2cUrl"
        class="whitespace-nowrap"
      >{{ $t('header.switchTo.b2c') }}</a>
    </div>
    <div
      ref="b2bRef"
      class="border-b-2 pb-4 desk:pb-10"
      :class="globalContent.getIsB2b
        ? 'type-headline-sm desk:type-headline-xs'
        : 'border-transparent opacity-75 hover:opacity-100 transition-all duration-300 ease-out'"
    >
      <a
        :href="b2bUrl"
        class="whitespace-nowrap"
      >{{ $t('header.switchTo.b2b') }}</a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalContentStore } from '~/store/globalContent';
import useStoryblokAdmin from '~/composables/useStoryblokAdmin';
import { storeToRefs } from 'pinia';

const storyblokAdmin = useStoryblokAdmin();
const globalContent = useGlobalContentStore();
const { customerType } = storeToRefs(globalContent);

const b2cRef = useTemplateRef<HTMLDivElement>('b2cRef');
const b2bRef = useTemplateRef<HTMLDivElement>('b2bRef');

const props = defineProps({
  invertTextColor: {
    type: Boolean,
    default: null,
  },
});

const textClass = computed(() => {
  if (props.invertTextColor === null) {
    return '';
  }
  return props.invertTextColor
    ? 'text-text-inverse border-text-inverse'
    : 'text-text-base border-text-base';
});

const b2cUrl = computed(() => {
  const domainMap = globalContent.domainMap;
  return `${domainMap?.url}/${domainMap?.b2c?.storyblokBasePath}?forceConsumerType=b2c`;
});

const b2bUrl = computed(() => {
  const domainMap = globalContent.domainMap;
  return `${domainMap?.url}/${domainMap?.b2b?.storyblokBasePath}?forceConsumerType=b2b`;
});

const activeClasses = ['type-headline-sm', 'desk:type-headline-xs'];
const inactiveClasses = ['border-transparent', 'opacity-75', 'hover:opacity-100', 'transition-all', 'duration-300', 'ease-out'];

const updateClasses = () => {
  const isB2c = (customerType.value === 'b2c');
  const isB2b = (customerType.value === 'b2b');

  if (b2cRef.value) {
    b2cRef.value.classList.remove(...activeClasses, ...inactiveClasses);
    b2cRef.value.classList.add(...(isB2c ? activeClasses : inactiveClasses));
  }

  if (b2bRef.value) {
    b2bRef.value.classList.remove(...activeClasses, ...inactiveClasses);
    b2bRef.value.classList.add(...(isB2b ? activeClasses : inactiveClasses));
  }
};

onMounted(updateClasses);
watch(customerType, updateClasses);
</script>